module.exports = __webpack_public_path__ + "static/media/angular.9ea6ab1d.webp";